import { ChangeDetectionStrategy, Component, forwardRef, input, InputSignal, signal, WritableSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { provideTranslationScope, TranslationPipeModule } from "@ogs-gmbh/ngx-translate";

@Component({
  selector: 'app-labeled-radiogroup',
  standalone: true,
  imports: [ CommonModule, MatRadioModule, TranslationPipeModule ],
  templateUrl: './labeled-radiogroup.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LabeledRadioGroupComponent),
      multi: true
    },
    provideTranslationScope("shared/labeled-radiogroup")
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LabeledRadioGroupComponent implements ControlValueAccessor {
  readonly label: InputSignal<string> = input('');

  protected value: WritableSignal<boolean | null> = signal(null);

  disabled: boolean = false;

  readonly firstRadioLabel: InputSignal<string> = input('');

  readonly secondRadioLabel: InputSignal<string> = input('');


  // eslint-disable-next-line @tseslint/class-methods-use-this,@tseslint/no-empty-function
  private onChangeFn: (value: boolean | null) => void = () => {};

  // eslint-disable-next-line @tseslint/class-methods-use-this,@tseslint/no-empty-function
  private onTouchedFn: () => void = () => {};

  writeValue (value: boolean | null): void {
    this.value.set(value);
  }

  registerOnChange (fn: (value: boolean | null) => void): void {
    this.onChangeFn = fn;
  }

  registerOnTouched (fn: () => void): void {
    this.onTouchedFn = fn;
  }

  setDisabledState? (isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onChange (value: boolean): void {
    this.value.set(value);
    this.onChangeFn(value);
    this.onTouchedFn();
  }
}
